
























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IClient } from "@/models/clients";
import {
  DefaultInvoicesFilters,
  InvoiceStatusFilter
} from "@/data/filters/invoice";
import { IInvoice } from "@/models/invoices";
import { DataModules } from "@/store/modules/data";

@Component({
  computed: {
    ...mapGetters({
      canShowNotesAndSecrets: "data/clients/vaultAssets/canShowNotesAndSecrets"
    })
  },
  components: {
    "client-provider": () =>
      import("@/components/app/global/client/clientProvider.vue"),
    "client-well-link": () =>
      import("@/components/app/admin/clients/clientWellLink.vue"),
    "tickets-table": () =>
      import("@/components/app/global/tickets/ticketsTable.vue"),
    "products-table": () =>
      import("@/components/app/global/contractProducts/productsTable.vue"),
    "invoices-listing": () =>
      import("@/components/app/global/invoices/invoicesListing.vue"),
    "client-notes-component": () =>
      import("@/components/app/global/client/clientNotesComp.vue"),
    "client-secrets-component": () =>
      import("@/components/app/global/client/clientSecretsComp.vue")
  }
})
export default class ClientQuickLookModal extends Vue {
  // Getters

  public canShowNotesAndSecrets!: boolean;

  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: "" })
  public clientIdentifier!: IClient["fullname"];

  // Computed

  public get invoiceListBindings() {
    return {
      id: "CIT1",
      clientId: this.clientId,
      dataScope: `$client::${this.clientId}`,
      availableInvoiceFilters: () => [
        ...DefaultInvoicesFilters(),
        InvoiceStatusFilter()
      ],
      rowProps: () => ({}), // Here we return {} to prevent rows acting as router-links
      rowEvents: (invoice: IInvoice) => ({
        click: () =>
          this.$store.dispatch(
            `data/${DataModules.INVOICES}/openPreviewModal`,
            {
              invoiceId: invoice.id
            }
          )
      })
    };
  }
}
